import { useState, useEffect, useCallback, useRef } from "react";
import api from "../utils/api"; // 🔥 ekledik
import { historyFetchPlan } from "../utils/historyWindow";

function toMinuteArrays(raw) {
  const out = {};
  for (const k in raw) {
    out[k] = Array.isArray(raw[k]) ? raw[k].map((v) => Number(v) || 0) : [];
  }
  return out;
}

export function useChannelData(channelId, refreshKey = 0) {
  const [channelInfo, setChannelInfo] = useState(null);
  const [rawVideo, setRawVideo] = useState(null);

  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState(null);

  const openChannel = useRef(channelId);
  openChannel.current = channelId;

  const fetchAll = useCallback(
    async (isRefresh = false) => {
      if (isRefresh) setRefreshing(true);
      else setLoading(true);

      setError(null);

      // Without an explicit start the reader falls back to three months.
      const plan = historyFetchPlan(channelId);

      try {
        const [channelRes, videoRes] = await Promise.all([
          api.get(`/ci?i=${channelId}`), // 🔥 değişti
          api.get(`/v?c=${channelId}&start=${plan.first}`),
        ]);

        if (openChannel.current !== channelId) return;

        setChannelInfo(channelRes.data?.[0] ?? null);
        setRawVideo(toMinuteArrays(videoRes.data));
      } catch (err) {
        console.error("Channel or video fetch error:", err);
        setError("Failed to load channel data.");
        return;
      } finally {
        if (isRefresh) setRefreshing(false);
        else setLoading(false);
      }

      // The older stretch is not on the critical path: the page is already
      // drawn by the time it lands, and the default views never look that far
      // back. Merged under what is on screen, so a slow answer cannot replace
      // fresher days.
      if (!plan.backfill) return;

      try {
        const res = await api.get(
          `/v?c=${channelId}&start=${plan.backfill.start}&end=${plan.backfill.end}`
        );
        if (openChannel.current !== channelId) return;
        const older = toMinuteArrays(res.data);
        setRawVideo((prev) => ({ ...older, ...(prev || {}) }));
      } catch (err) {
        // The recent window is already usable; older dates simply stay empty.
        console.error("Channel history backfill error:", err);
      }
    },
    [channelId]
  );

  useEffect(() => {
    if (!channelId) return;
    fetchAll(false);
  }, [channelId, fetchAll]);

  useEffect(() => {
    if (!refreshKey) return;
    fetchAll(true);
  }, [refreshKey, fetchAll]);

  return {
    channelInfo,
    rawVideo,
    loading,
    refreshing,
    error,
  };
}
